<style>
  input {
    background-color: #fff;
    box-sizing: border-box;
    flex: 1 1 auto;
    margin: 0.2em;
    padding: 0.3em;
    text-align: left;
    width: auto;
  }
  .columns {
    align-items: center;
    display: flex;
    flex-flow: row;
  }
  .desc {
    font-size: 0.8em;
    margin: 0.2em;
    padding: 0.3em 0.3em 0.3em 0.4em; /* top | right | bottom | left */
  }
  .desc-intend {
    font-size: 0.8em;
    margin: 0.2em 0.2em 0.2em 1.2em; /* top | right | bottom | left */
    padding: 0.3em 0.3em 0.3em 0.4em; /* top | right | bottom | left */
  }
  .do {
    font-size: 0.8em;
    margin: 0.3em 0.5em 0.5em 0.5em; /* top | right | bottom | left */
    padding: 0.4em;
    flex: 1 1 50%;
  }
  .first-row {
    align-items: center;
    display: flex;
    flex-flow: row;
  }
  .input_invalid {
    background-color: #fcc;
  }
  .item {
    align-items: left;
    background-color: #ffe;
    border-radius: 0.2em;
    border-width: 0em;
    box-shadow: 0.1em 0.1em 0.2em #555;
    display: flex;
    flex-flow: column;
    margin: 0.3em 0.4em 0.3em 0.4em; /* top | right | bottom | left */
    padding: 0.2em;
  }
  .more {
    cursor: pointer;
    flex: 0 0 auto;
    font-size: 0.8em;
    margin: 0.3em 0.5em 0.3em 0.3em; /* top | right | bottom | left */
    padding: 0.3em;
  }
  .name {
    cursor: pointer;
    flex: 1 1 auto;
    margin: 0em;
    padding: 0.5em;
  }
  .bullet {
    font-size: 1.3em;
    margin-right: 0.2em;
  }
  .change {
    color: #a44;
  }
  .no-change {
    color: #373;
  }
  .unknown {
    color: #aaa;
  }
</style>

<script>
  import { afterUpdate, onDestroy, onMount } from 'svelte';
  import config from '../../config';
  import {
    auth_logged_in,
    lang, leaflet_map,
    panel_selected,
    plots, plot_selected,
  } from '../store';
  import sync from '../sync';
  import util from '../util';
  
  function delete_cancel(event) {
    delete_mode = false;
  }
  async function delete_confirm() {
    plot_id = '';
    delete $plots[plot_seq];
    await sync.update_plot(plot_obj, 'delete');
    delete_mode = false;
  }
  function delete_plot(event) {
    delete_mode = true;
  }
  function enable_measure(enable) {
    if (enable) {
      $leaflet_map.on('pm:create', event => {
        event.layer.showMeasurements({
          formatArea: function(value) {
            value = value / 10000;
            return `${value.toFixed(2)} ha`;
          },
        });
      });
      if (!$leaflet_map.pm.controlsVisible()) {
        $leaflet_map.pm.addControls(config.geoman.measure_controls);
      }
    } else {
      if ($leaflet_map.pm.controlsVisible()) {
        $leaflet_map.pm.removeControls();
      }
      $leaflet_map.off('pm:create');
    }
  }
  function get_short_name(name) {
    if (name.length > display_name_len) {
      return name.substring(0, display_name_len - 1) + '...';
    } else {
      return name;
    }
  }
  function goto_plot(event) {
    $plot_selected = plot_seq;
    if (window.innerWidth < 800) {
      // on small screen have to use timeout so that panel is closed before going to polygon
      setTimeout(function() { 
        $leaflet_map.fitBounds([
          [plot_obj.extent.ymin, plot_obj.extent.xmin],
          [plot_obj.extent.ymax, plot_obj.extent.xmax]
        ]);
      }, 100);
      $panel_selected = '';
    } else {
      $leaflet_map.fitBounds([
        [plot_obj.extent.ymin, plot_obj.extent.xmin],
        [plot_obj.extent.ymax, plot_obj.extent.xmax]
      ]);
    }
  }
  function input_keypress(keyboard_event) {
    if (keyboard_event.key === 'Enter') {
      if (name_valid(rename_value)) {
        edit_confirm();
      }
    } else if (keyboard_event.key === 'Escape') {
      edit_cancel();
    }
  }
  function name_valid(name) {
    if (
      name.length >= config.input.plot.name.min_len
      && name.length <= config.input.plot.name.max_len
    ) {
      return true;
    } else {
      return false;
    }
  }
  function edit_plot(event) {
    // goto_plot();
    input_selected_once = false;
    rename_value = plot_obj.plot_name;
    edit_mode = true;
    enable_geom_editing(true);
  }
  function edit_cancel(event) {
    edit_mode = false;
    enable_geom_editing(false);
    sync.sync_plot(plot_obj);
  }
  async function edit_confirm(event) {
    edit_mode = false;
    enable_geom_editing(false);
    if (plot_obj.plot_name !== rename_value && name_valid(rename_value)) {
      plot_obj.plot_name = rename_value;
    }
    plot_obj.geojson = plot_obj.layer.pm._layers[0].pm._layer.toGeoJSON(6).geometry;
    plot_seq = await sync.update_plot(plot_obj, 'update');
    if (plot_seq in $plots) {
      plot_obj = $plots[plot_seq];
    }
  }
  function enable_geom_editing(enable) {
    if (enable) {
      enable_measure(false);
      plot_obj.layer.pm.enable({  
        allowSelfIntersection: false,  
      });
    } else {
      plot_obj.layer.pm.disable();
      enable_measure(true);
    }
  }
  function get_plot_attrs() {
    function get_attr_simple(attr_name, attr_value) {
      if (!attr_name) {
        console.error('Empty attr_name value');
        return '';
      }
      if (!attr_value && attr_value !== 0 && config.plots.main_attrs.indexOf(attr_name) < 0) {
        return '';
      }
      const caption = get_caption(attr_name);
      let value_str;
      if (attr_name === 'mon_date') {
        if (!attr_value && attr_value !== 0) {
          value_str = `<span class='status status-unknown'>${util.caption($lang, 'plot_attrs', 'mon_val_no_value')}</span>`;
        } else {
          value_str = `<span class='status status-blank'>${attr_value}</span>`;
        }
      } else if (attr_name === 'mon_result') {
        if (!attr_value && attr_value !== 0) {
          value_str = `<span class='status status-unknown'>${util.caption($lang, 'plot_attrs', 'mon_val_no_value')}</span>`;
        } else if (attr_value <= 0.3) {
          value_str = `<span class='status status-no-forest'>${util.caption($lang, 'plot_attrs', 'mon_val_no_forest')}</span>`;
        } else if (attr_value >= 0.7) {
          value_str = `<span class='status status-forest'>${util.caption($lang, 'plot_attrs', 'mon_val_forest')}</span>`;
        } else {
          value_str = `<span class='status status-other'>${util.caption($lang, 'plot_attrs', 'mon_val_other')}</span>`;
        }
      } else if (attr_name === 'mon_status') {
        if (!attr_value) {
          value_str = `<span class='status status-unknown'>${util.caption($lang, 'plot_attrs', 'mon_val_no_value')}</span>`;
        } else if (attr_value === 'initial') {
          value_str = `<span class='status status-unknown'>${util.caption($lang, 'plot_attrs', 'mon_val_initial')}</span>`;
        } else if (attr_value === 'unknown') {
          value_str = `<span class='status status-unknown'>${util.caption($lang, 'plot_attrs', 'mon_val_unknown')}</span>`;
        } else if (attr_value === 'change') {
          value_str = `<span class='status status-change'>${util.caption($lang, 'plot_attrs', 'mon_val_change')}</span>`;
        } else if (attr_value === 'no-change') {
          value_str = `<span class='status status-no-change'>${util.caption($lang, 'plot_attrs', 'mon_val_no_change')}</span>`;
        } else {
          console.error(`Unknown mon_status value ${attr_value}`);
          value_str = `<span class='status status-unknown' ${util.caption($lang, 'plot_attrs', 'mon_val_unknown')}</span>`;
        }
      } else if (!attr_value && attr_value !== 0) {
        value_str = util.caption($lang, 'plot_attrs', 'no_value');
      } else if (attr_name === 'area_ha') {
        value_str = `${attr_value.toFixed(2)} ${util.caption($lang, 'plot_attrs', 'area_units')}`;
      } else {
        value_str = `${attr_value}`;
      }
      return `${caption}: ${value_str}`
    }
    function get_attr_complex(attr_name, attr_value) {
      if (!attr_name) {
        console.error('Empty attr_name value');
        return [];
      }
      if (!attr_value) {
        return [];
      }
      let attrs = [];
      for (const key of Object.keys(attr_value).sort()) {
        const value_str = get_attr_simple(key, attr_value[key]);
        if (value_str) {
          attrs.push(value_str);
        }
      }
      return attrs;
    }
    function get_caption(attr_name) {
      if (config.plots.show_attrs.indexOf(attr_name) >= 0) {
        return util.caption($lang, 'plot_attrs', attr_name);
      } else if (config.plots.extra_attrs.indexOf(attr_name) >= 0) {
        return util.caption($lang, 'plot_attrs', attr_name);
      } else {
        attr_name = attr_name.replace(/_/g, ' ')
        return attr_name[0].toUpperCase() + attr_name.slice(1,);
      }
    }
    let attrs = [];
    for (const attr_name of config.plots.show_attrs) {
      if (['cad_nr', 'mon_date', 'mon_result', 'mon_status'].includes(attr_name)) {
        continue;
      }
      if (config.plots.complex_attrs.indexOf(attr_name) >= 0) {
        // complex attr
        const attr_values = get_attr_complex(attr_name, plot_obj[attr_name]);
        const caption = get_caption(attr_name);
        if (attr_values.length) {
          attrs.push(['desc', `${caption}:`]);
          for (const attr_value of attr_values) {
            attrs.push(['desc-intend', attr_value]);
          }
        } else {
          if (config.plots.main_attrs.indexOf(attr_name) >= 0) {
            const caption = util.caption($lang, 'plot_attrs', attr_name);
            const value_str = util.caption($lang, 'plot_attrs', 'no_value');
            attrs.push(['desc', `${caption}: ${value_str}`]);
          }
        }
      } else {
        // simple attr
        const attr_value = get_attr_simple(attr_name, plot_obj[attr_name]);
        if (attr_name === 'mon_status') {
          attrs.push(['desc', `${util.caption($lang, 'plot_attrs', 'mon_info')}:`]);
        }
        if (attr_value) {
          if (['mon_date', 'mon_status', 'mon_result'].indexOf(attr_name) >= 0) {
            attrs.push(['desc-intend', attr_value]);
          } else {
            attrs.push(['desc', attr_value]);
          }
        }
      }
    }
    return attrs;
  }
  function toggle_selected() {
    if ($plot_selected === plot_seq) {
      $plot_selected = '';
    } else {
      $plot_selected = plot_seq;
    };
  }
  function window_resize() {
    if (first_row && name) {
      if (window.innerWidth < 800) {
        var fontSize = parseFloat(window.getComputedStyle(name).getPropertyValue('font-size'));
        display_name_len = Math.floor((first_row.clientWidth - 65) / fontSize * 1.75);
      } else {
        display_name_len = default_display_name_len;
      }
    }
  }
  
  afterUpdate(() => {
    if ($plot_selected === plot_seq) {
      if (item) {
        item.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    } else {
      if (edit_mode) {
        enable_geom_editing(false);
        sync.sync_plot(plot_obj);
      }
      edit_mode = false;
      delete_mode = false;
    }
    if (input && submit) {
      if (!input_selected_once) {
        input.focus();
        input.select();
        input_selected_once = true;
      };
      if (name_valid(rename_value)) {
        submit.disabled = false;
        input_invalid = false;
      } else {
        submit.disabled = true;
        input_invalid = true;
      }
    }
  });
  
  onDestroy(() => {
    if (edit_mode) {
      enable_geom_editing(false);
      sync.sync_plot(plot_obj);
    }
  });
  
  onMount(() => {
    window_resize();
  });
  
  export let item_id;
  let plot_seq = item_id;
  
  let plot_id = '';
  let plot_obj = {};
  let plot_status = '';
  if (plot_seq in $plots) {
    plot_id = $plots[plot_seq].plot_id;
    plot_obj = $plots[plot_seq];
    let mon_status = '';
    if (plot_obj) {
      mon_status = plot_obj.mon_status;
    }
    if (!mon_status || mon_status === 'initial' || mon_status === 'unknown') {
      plot_status = 'bullet unknown';
    } else if (mon_status === 'change') {
      plot_status = 'bullet change';
    } else if (mon_status === 'no-change') {
      plot_status = 'bullet no-change';
    } else {
      console.error(`Unknown mon_status value ${mon_status}`);
      plot_status = 'bullet unknown';
    }
  }
  let plot_attrs = get_plot_attrs();
  
  const default_display_name_len = 29;
  let delete_mode = false;
  let display_name_len = default_display_name_len;
  let name;
  let input;
  let item;
  let first_row;
  let input_invalid = false;
  let input_selected_once;
  let edit_mode = false;
  let rename_value;
  let submit;
</script>

<svelte:window on:resize={window_resize}/>

{#if plot_id}
  <div bind:this={item} class='item'>
    <div class='first-row' bind:this={first_row}>
      {#if edit_mode}
        <input class:input_invalid type='text' minlength={config.input.plot.name.min_len} maxlength={config.input.plot.name.max_len} bind:value={rename_value} on:keydown={input_keypress} bind:this={input}>
      {:else}
        {#key display_name_len}
          <p class='name' bind:this={name} on:click={goto_plot}><span class={plot_status}>●</span> {get_short_name(plot_obj.plot_name)}</p>
        {/key}
      {/if}
      <p class='more' on:click={toggle_selected}>{$plot_selected === plot_seq ? util.caption($lang,'plot_panel','less') : util.caption($lang,'plot_panel','more')}</p>
    </div>
    {#if $plot_selected === plot_seq}
      {#each plot_attrs as plot_attr}
        <p class={plot_attr[0]}>{@html plot_attr[1]}</p>
      {/each}
      <div class='columns'>
        {#if edit_mode}
          <button class='do orange' on:click={edit_confirm} bind:this={submit}>{util.caption($lang,'plot_item','save')}</button>
          <button class='do green' on:click={edit_cancel}>{util.caption($lang,'plot_item','cancel')}</button>      
        {:else if delete_mode}
          <button class='do red' on:click={delete_confirm}>{util.caption($lang,'plot_item','confirm_del')}</button>
          <button class='do green' on:click={delete_cancel}>{util.caption($lang,'plot_item','cancel')}</button>
        {:else}
          <button class='do green' on:click={edit_plot}>{util.caption($lang,'plot_item','edit')}</button>
          <button class='do red' on:click={delete_plot}>{util.caption($lang,'plot_item','delete')}</button>
        {/if}
      </div>
    {/if}
  </div>
{/if}
